import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Login from "pages/Auth/Login";
import Logout from "pages/Auth/Logout";
import SignInOidc from "pages/Auth/SignInOidc";
import ForgotPassword from "pages/ForgotPassword";

import ErrorPage from "pages/NotFound/ErrorPage";
import UnlockLogin from "pages/Auth/UnlockLogin";

import ReleaseNotes from "pages/ReleaseNotes";

function PublicApp() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/error-page" component={ErrorPage} />
        <Route exact path="/unlock-login" component={UnlockLogin} />
        <Route exact path="/signin-oidc" component={SignInOidc} />
        <Route exact path="/release-notes" component={ReleaseNotes} />
        <Route path="/"> { /* redirect back to login if nothing match */}
          <Redirect to="/login" />
        </Route>
      </Switch>
    </Router>    
  );
}

export default PublicApp;
